import { AbstractCommand } from 'src/models/command';

class DeleteMemoCommand extends AbstractCommand {
	readonly name = 'IFS_IDO_IdoActivity_Command_Commands_DeleteIdoActivity';

	public constructor(aggregateId: string) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
		};
	}
}

export { DeleteMemoCommand };
